module.exports = __webpack_public_path__ + "img/Wp_2030.a59200f8.png";